import { render, staticRenderFns } from "@/style-guide/partials/dropUp/dropUp.pug?vue&type=template&id=a5a3149a&scoped=true&lang=pug&external"
import script from "./dropUp.vue?vue&type=script&lang=ts"
export * from "./dropUp.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5a3149a",
  null
  
)

export default component.exports